import {DriverContactFormServiceTypeEnum} from '@/services/api-clients';

export function driverContactFormServiceTypeIconFilter(type: DriverContactFormServiceTypeEnum) {
  switch (type){
    case DriverContactFormServiceTypeEnum.Taxi: return 'mdi-taxi';
    case DriverContactFormServiceTypeEnum.Courier: return 'mdi-moped';
    case DriverContactFormServiceTypeEnum.BikeService: return 'mdi-tools';
    case DriverContactFormServiceTypeEnum.Unknown: return 'mdi-help';
  }
}
